import {ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedImports} from '@shared/shared-imports';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {GenericSelectModel} from '@app/models/generic-select.model';
import {ContextService} from '@services/context.service';
import {takeUntil} from 'rxjs/operators';
import {MessageService} from 'primeng/api';
import {Subject} from 'rxjs';
import {AddressFormCustomComponent} from '@shared/components/address-form-custom/address-form-custom.component';
import {AddressModel} from '@app/models/addresses.model';
import {OrganizationRegistrationModel} from '@app/models/organizations.model';
import {SelfRegistrationModel} from '@app/models/user-registration.model';
import {UserRegistrationService} from '@services/user-registration.service';

@Component({
  selector: 'app-registration-page-4',
  templateUrl: './registration-page-4-address.component.html',
  styleUrls: ['./registration-page-4-address.component.scss'],
  imports: [
    SharedImports,
    AddressFormCustomComponent
  ]
})

export class RegistrationPage4AddressComponent implements OnInit, OnChanges {
  mainForm: FormGroup;
  inputObjState: GenericSelectModel;
  setStateId: number;
  incomingAddressMailing = {} as AddressModel;
  incomingAddressBilling = {} as AddressModel;
  isSaving: boolean = false;
  @Input() registrationProfile: SelfRegistrationModel;
  @Input() tenantName: string = 'iaff';
  @Output() next = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  @Input() campaignId: number;
  @Input() organizationDetails: OrganizationRegistrationModel;
  legal = '';
  private ngUnsubscribe = new Subject();

  constructor(private formBuilder: FormBuilder,
              public contextService: ContextService, private userRegistrationService: UserRegistrationService,
              private messageService: MessageService, private changeDetection: ChangeDetectorRef,) {
    this.mainForm = this.formBuilder.group({
      address: new FormControl(null, [Validators.required]),
      address2: new FormControl(null),
      city: new FormControl(null, [Validators.required]),
      state: new FormControl(null, [Validators.required]),
      zipCode: new FormControl(null, [Validators.required]),
      agree: new FormControl(null, [Validators.required]),
      useMailing: new FormControl(null)
    });
  }

  ngOnInit() {
    document.querySelector('.page-container-public').scrollIntoView(true);
    // console.log(this.orgCampaignDetails);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.registrationProfile.PaymentMethod) {
      this.mainForm.get('address').setValue(this.registrationProfile.PaymentMethod.Address1);
      this.mainForm.get('address2').setValue(this.registrationProfile.PaymentMethod.Address2);
      this.mainForm.get('city').setValue(this.registrationProfile.PaymentMethod.City);
      this.mainForm.get('state').setValue(this.registrationProfile.PaymentMethod.StateProvinceID);
      this.setStateId = this.registrationProfile.PaymentMethod.StateProvinceID;
      this.mainForm.get('zipCode').setValue(this.registrationProfile.PaymentMethod.Zip);
      const tempAddress = {} as AddressModel;
      tempAddress.Address1 = this.registrationProfile.PaymentMethod.Address1;
      tempAddress.Address2 = this.registrationProfile.PaymentMethod.Address2;
      tempAddress.City = this.registrationProfile.PaymentMethod.City;
      tempAddress.StateProvinceID = this.registrationProfile.PaymentMethod.StateProvinceID;
      tempAddress.Zip = this.registrationProfile.PaymentMethod.Zip;
      this.incomingAddressBilling = tempAddress;
      // console.log(this.incomingAddressBilling);
    }

    if (this.organizationDetails) {
      switch (this.tenantName) {
        case 'IAFF': {
          this.legal = 'I wish to join IAFF\'s organization. I understand that, by becoming a member of IAFF\'s organization, ' +
            'I am agreeing that IAFF may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining IAFF, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my IAFF membership dues.';
          break;
        }
        case 'IFPTE': {
          this.legal = 'I wish to join IFPTE\'s organization. I understand that, by becoming a member of IFPTE\'s organization, ' +
            'I am agreeing that IFPTE may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining IFPTE, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my IFPTE membership dues.';
          break;
        }
        case 'MSCEA': {
          this.legal = 'I wish to join MSCEA\'s organization. I understand that, by becoming a member of MSCEA\'s organization, ' +
            'I am agreeing that MSCEA may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining MSCEA, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my MSCEA membership dues.';
          break;
        }
        case 'UNIONTRACK': {
          this.legal = 'I wish to join UNIONTRACK\'s organization. I understand that, by becoming a member of UNIONTRACK\'s organization, ' +
            'I am agreeing that UNIONTRACK may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining UNIONTRACK, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my UNIONTRACK membership dues.';
          break;
        }
        case 'UNIONTRACK2': {
          this.legal = 'I wish to join UNIONTRACK2\'s organization. I understand that, by becoming a member of UNIONTRACK2\'s organization, ' +
            'I am agreeing that UNIONTRACK2 may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining UNIONTRACK2, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my UNIONTRACK2 membership dues.';
          break;
        }
        case 'UNIOINTRACKDOC': {
          this.legal = 'I wish to join UNIOINTRACKDOC\'s organization. I understand that, by becoming a member of UNIOINTRACKDOC\'s organization, ' +
            'I am agreeing that UNIOINTRACKDOC may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining UNIOINTRACKDOC, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my UNIOINTRACKDOC membership dues.';
          break;
        }
        case 'NWSEO': {
          this.legal = 'The member will be charged a credit card processing fee based on the payment amount. A $2.00 flat fee will apply if dues are less ' +
            'than (or equal to) $60 or a 3% fee will apply if dues are $60.01 or more. \n \n' + 'After registering as a member, you will have the option to change your payment method to Bank Draft (ACH) with no fees.'
            + '\n \nI wish to join this organization. I understand that, by becoming a member of the organization, ' +
            'I am agreeing that the organization may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining the organization, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my membership dues.';
          break;
        }
        default: {
          this.legal = 'I wish to join this organization. I understand that, by becoming a member of the organization, ' +
            'I am agreeing that the organization may be certified to serve as my exclusive representative for the purposes of union representation ' +
            'and collective bargaining. I will be joining the organization, and my designated local, as a regular dues paying member based on the ' +
            'dues structure set forth by the bylaws of that local. I understand that I will be charged on a recurring, monthly basis for ' +
            'my membership dues.';
          break;
        }
      }

    }
    this.initData();
  }

  initData() {
    this.mainForm.valueChanges.subscribe(data => {
      //this.registrationProfile.PaymentMethod = {} as PaymentMethodModel;
      this.registrationProfile.PaymentMethod.Address1 = this.mainForm.get('address').value;
      this.registrationProfile.PaymentMethod.Address2 = this.mainForm.get('address2').value;
      this.registrationProfile.PaymentMethod.City = this.mainForm.get('city').value;
      this.registrationProfile.PaymentMethod.StateProvinceID = this.mainForm.get('state').value;
      this.registrationProfile.PaymentMethod.Zip = this.mainForm.get('zipCode').value;
      this.updateData.emit(this.registrationProfile);
    });
    this.mainForm.get('useMailing').valueChanges.subscribe(value => {
      // console.log(value);
      if (value === true) {
        // console.log('in here');
        const tempAddress = {} as AddressModel;
        this.incomingAddressBilling = null;
        this.changeDetection.detectChanges();
        this.mainForm.get('address').setValue(this.registrationProfile.Address1);
        this.mainForm.get('address2').setValue(this.registrationProfile.Address2);
        this.mainForm.get('city').setValue(this.registrationProfile.City);
        this.mainForm.get('state').setValue(this.registrationProfile.StateProvinceID);
        this.mainForm.get('zipCode').setValue(this.registrationProfile.Zip);
        tempAddress.Zip = this.registrationProfile.Zip;
        tempAddress.Address1 = this.registrationProfile.Address1;
        tempAddress.Address2 = this.registrationProfile.Address2;
        tempAddress.City = this.registrationProfile.City;
        tempAddress.StateProvinceID = this.registrationProfile.StateProvinceID;
        this.incomingAddressBilling = tempAddress;
        // console.log(this.incomingAddressBilling);
        this.changeDetection.detectChanges();
        this.setStateId = this.registrationProfile.StateProvinceID;
      } else {
        this.mainForm.get('address').setValue(null);
        this.mainForm.get('address2').setValue(null);
        this.mainForm.get('city').setValue(null);
        this.mainForm.get('state').setValue(null);
        this.mainForm.get('zipCode').setValue(null);
        this.setStateId = null;
      }
    });
  }

  goToNextPage() {
    this.processData();
  }

  setAddress(addressChanges: AddressModel): void {
    if (addressChanges) {
      // console.log(addressChanges);
      this.mainForm.markAsDirty();
      //this.registrationProfile.CountryID = 1;
      this.registrationProfile.PaymentMethod.Address1 = addressChanges.Address1;
      this.registrationProfile.PaymentMethod.Address2 = addressChanges.Address2;
      this.registrationProfile.PaymentMethod.City = addressChanges.City;
      this.registrationProfile.PaymentMethod.StateProvinceID = addressChanges.StateProvinceID;
      this.registrationProfile.PaymentMethod.Zip = addressChanges.Zip;
      this.mainForm.get('address').setValue(addressChanges.Address1);
      this.mainForm.get('address2').setValue(addressChanges.Address2);
      this.mainForm.get('city').setValue(addressChanges.City);
      this.mainForm.get('state').setValue(addressChanges.StateProvinceID);
      this.mainForm.get('zipCode').setValue(addressChanges.Zip);
      this.updateData.emit(this.registrationProfile);
    }
  }

  processData() {
    this.isSaving = true;
    this.saveData();
  }

  saveData() {
    this.userRegistrationService.selfRegistration(this.registrationProfile)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (res) => {
          this.messageService.add({severity: 'success', summary: 'Success', detail: 'Your registration has been processed successfully.'});
          this.next.emit();
          this.isSaving = false;
        }, error: (e) => {
          console.log(e);
          if (e?.error?.Message) {
            this.messageService.add({severity: 'error', summary: 'Error', detail: e.error.Message.replace('UM: ', ''), life: 5000});
          } else {
            this.messageService.add({severity: 'error', summary: 'Error', detail: 'Our apologies... An error occurred. Please try again and let us know if it continues. Thank you!'});
          }
          this.isSaving = false;
        }
      });
  }
}
